export default __webpack_public_path__ + "static/customize-universal-checkout-81aecba818b2c7134ea001dd418aa221.png";